import React from 'react'

export const Button = ({classes, text}) => {
  return (
    <button className={`font-oxanium uppercase bg-[linear-gradient(90deg,_rgba(8,215,185,1)_0%,_rgba(16,170,240,1)_33%,_rgba(98,65,246,1)_66%,_rgba(169,2,255,1)_100%)] text-white ${classes}`}>{text}</button>
  )
}
